// GENERATED by scripts/gen-org-repos.mjs — do not edit by hand.
// MAINTENANCE ARTIFACT: a static snapshot of the attentive-mobile org repos used
// to seed the new-job repo combobox (A1EE-338). It goes stale; regenerate with
// `node scripts/gen-org-repos.mjs`. Free-text entry is always allowed, so a
// missing repo is a convenience gap, not a hard block.

export const DEFAULT_REPO = 'attentive-mobile/code';

export const ORG_REPOS: readonly string[] = [
  'attentive-mobile/.github',
  'attentive-mobile/3p-ui',
  'attentive-mobile/a1e-access-gateway',
  'attentive-mobile/a1e-docker-images',
  'attentive-mobile/a1e-envs',
  'attentive-mobile/a1e-evaluation-engine',
  'attentive-mobile/a1ec',
  'attentive-mobile/a1ec-cli',
  'attentive-mobile/a1ec-frontend',
  'attentive-mobile/a1ee-terraform',
  'attentive-mobile/ab-test',
  'attentive-mobile/accounting-month-end',
  'attentive-mobile/ace-platform',
  'attentive-mobile/aggregator-model',
  'attentive-mobile/ai-assisted-interview',
  'attentive-mobile/ai-docs',
  'attentive-mobile/airflow',
  'attentive-mobile/alekskt',
  'attentive-mobile/ansible',
  'attentive-mobile/api-examples',
  'attentive-mobile/atc',
  'attentive-mobile/attentive-alfred',
  'attentive-mobile/attentive-android-sdk',
  'attentive-mobile/attentive-app-config-2026',
  'attentive-mobile/attentive-flutter-sdk',
  'attentive-mobile/attentive-flyway',
  'attentive-mobile/attentive-gtm-sdk',
  'attentive-mobile/attentive-incidents',
  'attentive-mobile/attentive-ios-sdk',
  'attentive-mobile/attentive-platform-org-thoughts',
  'attentive-mobile/attentive-react-native-example',
  'attentive-mobile/attentive-react-native-sdk',
  'attentive-mobile/attentive-unity-sdk',
  'attentive-mobile/attn-k8s-platform-learning',
  'attentive-mobile/attn-slack',
  'attentive-mobile/base-images',
  'attentive-mobile/build-engineer-coding-exercise',
  'attentive-mobile/build-engineer-coding-exercise-examples',
  'attentive-mobile/butler',
  'attentive-mobile/career-ladder',
  'attentive-mobile/carrier-fees-model',
  'attentive-mobile/ci_secrets_keeper',
  'attentive-mobile/claude-devtools',
  'attentive-mobile/claude-plugins',
  'attentive-mobile/claude-test-fixed',
  'attentive-mobile/claude-test-repo',
  'attentive-mobile/cli',
  'attentive-mobile/cloud-cost-tools',
  'attentive-mobile/code',
  'attentive-mobile/code-guru-test',
  'attentive-mobile/coder-base-dotfile',
  'attentive-mobile/codetools',
  'attentive-mobile/config',
  'attentive-mobile/Core-Email',
  'attentive-mobile/cortex-data-quality-poc',
  'attentive-mobile/cronjobs',
  'attentive-mobile/dagstar',
  'attentive-mobile/data-quality-alert-triaging',
  'attentive-mobile/data-science',
  'attentive-mobile/devops-reports',
  'attentive-mobile/devops-tools',
  'attentive-mobile/dip-docs',
  'attentive-mobile/discussion-thread',
  'attentive-mobile/discussions',
  'attentive-mobile/dmachat-skills',
  'attentive-mobile/docker',
  'attentive-mobile/druid',
  'attentive-mobile/dx-oncall',
  'attentive-mobile/eks-onboard',
  'attentive-mobile/eng-it-support',
  'attentive-mobile/engineering',
  'attentive-mobile/engineering-prompts',
  'attentive-mobile/epd-execution-tracker',
  'attentive-mobile/finance',
  'attentive-mobile/flink-cdc-connectors',
  'attentive-mobile/flink-connector-clickhouse',
  'attentive-mobile/flink-connector-pulsar',
  'attentive-mobile/flyway',
  'attentive-mobile/frontend-code',
  'attentive-mobile/gradle-cortex-extractor',
  'attentive-mobile/gradle-plugins',
  'attentive-mobile/harness',
  'attentive-mobile/helm-charts',
  'attentive-mobile/hive',
  'attentive-mobile/hive-extensions',
  'attentive-mobile/homebrew-tools',
  'attentive-mobile/hudi',
  'attentive-mobile/iac-poc',
  'attentive-mobile/intake-site',
  'attentive-mobile/integrations',
  'attentive-mobile/intellij-attentive-dx',
  'attentive-mobile/interview_override',
  'attentive-mobile/interview-questions',
  'attentive-mobile/it-eng-corp-sec',
  'attentive-mobile/jenkins-shared-libraries',
  'attentive-mobile/k8s-infra-base',
  'attentive-mobile/k8s-manifests',
  'attentive-mobile/k8s-policies',
  'attentive-mobile/knock',
  'attentive-mobile/knowledge-bot',
  'attentive-mobile/kubetun',
  'attentive-mobile/legacy-web',
  'attentive-mobile/llm-wrapper-experiment',
  'attentive-mobile/looker',
  'attentive-mobile/looker_legacy',
  'attentive-mobile/looker-content-snapshots',
  'attentive-mobile/looker-privy',
  'attentive-mobile/machine-learning',
  'attentive-mobile/markdoxide',
  'attentive-mobile/merge-queue-poc',
  'attentive-mobile/metrics-platform-tools',
  'attentive-mobile/neptune-db-proxy',
  'attentive-mobile/netsuite-salto',
  'attentive-mobile/netsuite-salto-finsys',
  'attentive-mobile/netsuite-sdf',
  'attentive-mobile/nlp-classifier',
  'attentive-mobile/notion-okr-scraper',
  'attentive-mobile/observability',
  'attentive-mobile/optimization-agent',
  'attentive-mobile/pd-oncall-chat-topic',
  'attentive-mobile/pmo',
  'attentive-mobile/pontifex',
  'attentive-mobile/privy-analytics',
  'attentive-mobile/product-design',
  'attentive-mobile/product-mgmt',
  'attentive-mobile/proj-unit-cost-analysis',
  'attentive-mobile/qpid',
  'attentive-mobile/qpid-idvq-pilot',
  'attentive-mobile/rds-connector',
  'attentive-mobile/rds-iam-sync',
  'attentive-mobile/readme-portal',
  'attentive-mobile/repo-factory',
  'attentive-mobile/required-workflows',
  'attentive-mobile/revops',
  'attentive-mobile/ricardo',
  'attentive-mobile/sales-gpt-calc',
  'attentive-mobile/salesforce',
  'attentive-mobile/segp-misc',
  'attentive-mobile/semgrep-test',
  'attentive-mobile/sender-ops-console',
  'attentive-mobile/service-creation-test',
  'attentive-mobile/slack-app-factory',
  'attentive-mobile/snowflake',
  'attentive-mobile/snowflake-native-app',
  'attentive-mobile/spring-layered-properties',
  'attentive-mobile/sqs-demo',
  'attentive-mobile/team-identity-scripts',
  'attentive-mobile/terraform',
  'attentive-mobile/terraform-playground',
  'attentive-mobile/test-gh-cli-creation',
  'attentive-mobile/test-requester-teams-final',
  'attentive-mobile/tf-attentive-root',
  'attentive-mobile/toll-free-agent',
  'attentive-mobile/toll-free-agent-local',
  'attentive-mobile/udangel-scripts',
  'attentive-mobile/udangel-skills',
  'attentive-mobile/v2-container-runtime-test',
  'attentive-mobile/vladimirpick-analysis',
] as const;
